import { createFileRoute, redirect } from '@tanstack/react-router'

/** Kept as a redirect — the profile moved to the My account surface. */
export const Route = createFileRoute('/_authenticated/$workspaceSlug/settings/profile')({
  beforeLoad: ({ params }) => {
    throw redirect({ params, to: '/$workspaceSlug/account/profile' })
  },
})
